export * from '../dist/index.mjs';



//////////////////
// WEBPACK FOOTER
// ./~/@stripe/stripe-js/lib/index.mjs
// module id = 819
// module chunks = 180